/** Whether this workspace role may manage agents in the workspace. */
export const canShowAgentActionMenu = (
  workspaceRole: string | null | undefined,
): boolean => workspaceRole === "owner" || workspaceRole === "admin";
